import services from "../services";

const strict = true;

const state = {
  mail: "",
  phone: "",
  step: 1
};

const getters = {
  mail: state => state.mail,
  phone: state => state.phone,
  step: state => state.step
};

const mutations = {
  mail(state, mail) {
    state.mail = mail;
  },
  phone(state, phone) {
    state.phone = phone;
  },
  step(state, step) {
    state.step = step;
  },
  reset(state) {
    state.step = 1;
    state.mail = "";
    state.phone = "";
  }
};

const actions = {
  /**
   * if channel is SMS (S) --> use the new phone number and the current email address (email3)
   * if channel is EMAIL (E) --> use the new email address and the current phone number (telefono3)
   */
  async verifyUserContactData({ commit, rootGetters }, payload) {
    try {
      commit("loading/openLoadingDialog", null, { root: true });
      let fiscalCode = rootGetters["login/userInfo"].codiceFiscale;
      let currentEmail3 = rootGetters["login/userInfo"].email3;
      let currentTelefono3 = rootGetters["login/userInfo"].telefono3;
      let obj = {
        fiscalCode: fiscalCode
      };
      if (payload.channel === "S") {
        // verify the new phone number
        obj["email"] = currentEmail3;
        obj["telefono"] = payload.value;
      } else {
        // verify the new email address
        obj["email"] = payload.value;
        obj["telefono"] = currentTelefono3;
      }
      return await services.profileService.callVerifyUserContactData(obj);
    } catch (error) {
      let errorDetails = {
        ...error
      };
      commit("error/setError", errorDetails, { root: true });
    } finally {
      commit("loading/reset", null, { root: true });
    }
  },
  /**
   * if channel is SMS (S) --> call sendOTPsms
   * if channel is EMAIL (E) && voucherMode is CRYPTED (C) --> call sendOTPsms
   * if channel is EMAIL (E) --> call sendOTPmail
   */
  async sendConfirmationCodeTo({ commit }, { channel, value, voucherMode }) {
    try {
      commit("loading/openLoadingDialog", null, { root: true });
      if (channel === "S") {
        await services.profileService.sendOTPsms(value);
      } else if (
        channel === "E" &&
        voucherMode != null &&
        voucherMode === "C"
      ) {
        await services.profileService.sendOTPsms(value);
      } else if (channel === "E") {
        await services.profileService.sendOTPmail(value);
      } else {
        commit(
          "error/setError",
          "dialog.error.invalidSendConfirmationCodeParams",
          {
            root: true
          }
        );
      }
    } catch (error) {
      let errorDetails = {
        ...error
      };
      commit("error/setError", errorDetails, { root: true });
    } finally {
      commit("loading/reset", null, { root: true });
    }
  },
  /**
   * - if channel is SMS (S) --> call certifyPhoneOtp
   * - if channel is EMAIL (E) && voucherMode is CRYPTED (C) --> call certifyPhoneOtp
   * - if channel is EMAIL (E) --> call certifyEmailOtp
   */
  async verifyCode({ commit }, { channel, value, voucherMode, otp }) {
    try {
      commit("loading/openLoadingDialog", null, { root: true });
      if (channel === "S") {
        await services.profileService.certifyPhoneOtp({ phone: value, otp });
      } else if (
        channel === "E" &&
        voucherMode != null &&
        voucherMode === "C"
      ) {
        await services.profileService.certifyPhoneOtp({ phone: value, otp });
      } else if (channel === "E") {
        await services.profileService.certifyEmailOtp({ email: value, otp });
      } else {
        commit("error/setError", "dialog.error.invalidVerifyCodeParams", {
          root: true
        });
      }
      commit("step", 2);
    } catch (error) {
      let errorDetails = {
        ...error
      };
      commit("error/setError", errorDetails, { root: true });
    } finally {
      commit("loading/reset", null, { root: true });
    }
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
